import { render, staticRenderFns } from "./input-type.vue?vue&type=template&id=563f823c&"
import script from "./input-type.vue?vue&type=script&lang=js&"
export * from "./input-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports